import {useEffect} from 'react';
import './nested-menu-item.css';

import {Divider, Menu} from '@mui/material';

import useProjects from '../../hooks/providers/useProjects';
import useUpload from '../../hooks/providers/useUpload';
import {projectShape} from '../../proptypes-shapes';
import ActualizeDataMenu from './single-project-item/features/actualize-data-button/ActualizeDataMenu';
import ProjectMenuDeleteButton from './single-project-item/features/delete-button/ProjectMenuDeleteButton';
import EmmaiMonthlyRestitutionButton from './single-project-item/features/EmmaiMonthlyRestitutionButton/EmmaiMonthlyRestitutionButton';
import FormsListMenu from './single-project-item/features/forms-list-button/FormsListMenu';
import ProjectMenuImportDataButton from './single-project-item/features/import-data-button/ProjectMenuImportDataButton';
import ProjectMenuManageUsersButton from './single-project-item/features/manage-users-button/ProjectMenuManageUsersButton';
import ProjectMenuUpdateButton from './single-project-item/features/update-button/ProjectMenuUpdateButton';

const ProjectCardMenu = ({project}) => {
  const {isUploadFilesModalOpen} = useUpload();
  const {projectCardMenuAnchorEl, selectedProject, closeProjectMenu} = useProjects();
  const anchorEl = projectCardMenuAnchorEl;

  const open = Boolean(anchorEl && selectedProject?.siren === project.siren);

  useEffect(() => {
    if (!isUploadFilesModalOpen) {
      closeProjectMenu();
    }
  }, [isUploadFilesModalOpen]);

  return (
    <Menu
      id="project-menu"
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      open={open}
      onClose={closeProjectMenu}
    >
      <ProjectMenuUpdateButton />

      <ProjectMenuManageUsersButton />

      <ProjectMenuImportDataButton />

      {open && <ActualizeDataMenu isNested />}

      {/* <FormsListMenu /> */}

      <Divider sx={{my: 0.5}} />
      <ProjectMenuDeleteButton />
    </Menu>
  );
};

ProjectCardMenu.propTypes = {
  project: projectShape.isRequired
};

export default ProjectCardMenu;
